import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-watch',
  templateUrl: './wallet-watch.component.html',
  styleUrls: ['./wallet-watch.component.scss']
})
export class WalletWatchComponent {

}
